import { getCostsByPlanAndUnits, getLocalizedPrice, getPackageCosts } from '../utils/costs';

const getTotalCostsByCostsTable = (costsTable) => {
	return costsTable.reduce((acc, [, cost]) => acc + cost, 0);
};

const getCostsPerYear = (costs) => costs * 12;

const getRecurringCostsLabel = (getLabel, totalRecurringCosts, paymentInterval, currency, locale, prices, showPricePerUnit) => {
	const recurringTotalLabel = [getLabel('quote_recurring_monthly')];

	if (showPricePerUnit) {
		const price = getLocalizedPrice(prices.monthly.perUnit, currency, locale);
		const label = getLabel('plan_price_per_unit').replace('%s', price);

		recurringTotalLabel.push(label);
	}

	if (paymentInterval === 'annually') {
		const recurringCostsPerYear = getCostsPerYear(totalRecurringCosts);
		const annualCostsHint = getLabel('payment_hint_annually').replace('%s', getLocalizedPrice(recurringCostsPerYear, currency, locale));
		recurringTotalLabel.push(annualCostsHint);
	}

	return recurringTotalLabel;
};

const formatCostsInTable = (costsTable, currency, locale) => {
	return costsTable.map(([item, costs]) => [item, getLocalizedPrice(costs, currency, locale)]);
};

export const useQuote = ({ consultingPackages, userData, currency, locale, plan, getLabel, useDecimalPlaces, showPricePerUnit }) => {
	const quote = { 'one-time': [], recurring: [] };
	const recurringCosts = [];
	const oneTimeCosts = [];

	const unitLabel = `${userData.units} ${getLabel('plan_units')}`;

	// * Add the costs for the plan and units (on a monthly basis)
	const costsForPlan = getCostsByPlanAndUnits(plan, userData.units, userData.paymentInterval, useDecimalPlaces);

	if (costsForPlan.monthly.plan === 0) {
		// If the plan is free, combine the plan and unit costs into a single line
		const itemName = `${plan.name} – ${unitLabel}`;
		recurringCosts.push([itemName, costsForPlan.monthly.units]);
	} else {
		// 1. Add the plan costs
		recurringCosts.push([plan.name, costsForPlan.monthly.plan]);

		// 2. Add the unit costs
		recurringCosts.push([unitLabel, costsForPlan.monthly.units]);
	}

	// * Add the costs for consulting packages
	userData.packages.forEach((packageID) => {
		// Determine whether the package has recurring costs
		const packageData = consultingPackages.find((consultingPackage) => consultingPackage.ID === packageID);
		if (packageData) {
			const { state } = plan.consulting_packages.available_packages.find((availablePackage) => availablePackage.id === packageID);
			const packageCosts = getPackageCosts(packageData, state, 'monthly', useDecimalPlaces);
			(packageData.cost_type === 'recurring' ? recurringCosts : oneTimeCosts).push([packageData.name, packageCosts]);
		}
	});

	// * Add the one time costs to the quote
	quote['one-time'].push(...formatCostsInTable(oneTimeCosts, currency, locale));
	quote['one-time'].push([getLabel('quote_one_time'), getLocalizedPrice(getTotalCostsByCostsTable(oneTimeCosts), currency, locale)]);

	// * Add the recurring costs to the quote
	quote.recurring.push(...formatCostsInTable(recurringCosts, currency, locale));
	const totalRecurringCosts = getTotalCostsByCostsTable(recurringCosts);
	quote.recurring.push([
		getRecurringCostsLabel(getLabel, totalRecurringCosts, userData.paymentInterval, currency, locale, costsForPlan, showPricePerUnit),
		getLocalizedPrice(totalRecurringCosts, currency, locale),
	]);

	return quote;
};
